module.exports = __webpack_public_path__ + "img/郁金.be93852b.jpg";